$(function () {
	var sidebar = new StickySidebar('.content-area .page-sidebar', {
		topSpacing: 100,
		bottomSpacing: 20,
		containerSelector: '.content-area',
		innerWrapperSelector: '.page-sidebar__wrapper',
		minWidth: 991,
	});
});